import './styles.scss'

import I18n from 'lib/i18n'
import React from 'react'
import { useValues } from 'kea'

import sceneLogic from '~/scenes/search/logic'

export default function MobileBreadcrumb () {
  const {
    results: { breadcrumbs, count }
  } = useValues(sceneLogic)
  return (
    <div className='grid responsive-full-grid search-breadcrumbs-map-results'>
      <div className={!count ? 'no-results-found' : 'with-reviews'}>
        <div className='widget nospace'>
          <h3 className='boxtitle line'>{I18n.t('courses.index.breadcrumbs_bottom_section_title')}</h3>
          <div className='padding-no-top2'>
            <strong>
              <a href={breadcrumbs.root.url}>
                <em className='rootTitle'>{breadcrumbs.root.title}</em>
              </a>
            </strong>
            <div className='breadcrumb-bottom-child'>
              <div className='main'>
                {breadcrumbs.links.map(link => (
                  <div className='with-comma' key={link.url}>
                    <a href={link.url} className='categoryUrl'>
                      <em className='categoryTitle'>{link.title}</em>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
